import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { Subject } from 'rxjs';

declare var $ : any;

@Component({
	selector: 'app-sign-up',
	templateUrl: './sign-up.component.html',
	styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {

	signUpForm : FormGroup;
	private url = environment.url;
	response :any;
	stations : string[] = [];

	constructor( private http : Http, private router : Router) { }

	ngOnInit() {
		this.signUpForm = new FormGroup ({
			"username" : new FormControl(null, Validators.required),
			"password" : new FormControl(null, Validators.required),
			"confirmPassword" : new FormControl(null, Validators.required),
			"role" : new FormControl(null, Validators.required),
			"branch" : new FormControl(null, Validators.required)
		});
		this.getBranch();
	};


	getBranch(){
		this.http.get(this.url + "/branch/all")
		.subscribe(branch=>{
			console.log(branch);
			var branches = branch.json();
			for (var i = 0; i < branches.length; ++i) {
				this.stations.push(branches[i]['branch_name'])
			}
		});
	}

	submit(){
		console.log(this.signUpForm.value);
		this.http.post(this.url + "/register", this.signUpForm.value)
		.subscribe(res => {
			console.log(res);
			this.response = res.json();
			console.log(this.response);
			console.log(this.response.status);
			if(this.response.status){

				if (this.response.message === 'User added successfully')
				{
					swal(
						' Success',
						'User added Successfully',
						'success'
					);
					this.router.navigate(['/dashboard']);
				}

				if (this.response.message === 'User Exists')
				{
					swal(
						' Info ',
						'User Already Exists',
						'info'
					);
				}
			}
			else{
				swal(
					'ERROR',
					'Please Enter Valid Username and Password',
					'error'
				);
			}
		});
	};
}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/auth/sign-up/sign-up.component.ts